import { render, staticRenderFns } from "./numeral.vue?vue&type=template&id=dcecfdea&"
import script from "./numeral.vue?vue&type=script&lang=js&"
export * from "./numeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports